import React from 'react';
import PropTypes from 'prop-types';

import { SponsorInfo } from 'Components/molecules/SponsorInfo';

/**
 *
 * @param {object} sponsor
 * @returns {JSX.Element|boolean}
 */
export const getSponsorInfo = ({
  sponsor,
}) => {
  if (sponsor === null) {
    return false;
  }

  return (
    <SponsorInfo {...sponsor} />
  );
};

getSponsorInfo.propTypes = {
  sponsor: PropTypes.shape(),
};

getSponsorInfo.defaultProps = {
  sponsor: [],
};
